import { IScoreboardResponse } from "@finbackoffice/clientbff-client";

export const useTennisGameScore = (scoreboard: IScoreboardResponse | null) => {
    const homeGameScore = scoreboard?.home_gamescore === 50 ? "A" : scoreboard?.home_gamescore;

    const awayGameScore = scoreboard?.away_gamescore === 50 ? "A" : scoreboard?.away_gamescore;

    return {
        homeGameScore: homeGameScore || null,
        awayGameScore: awayGameScore || null,
    };
};
